// react imports
import React from "react";

// package imports
import { Row, Col } from "react-bootstrap";
import { observer } from "mobx-react";
import { BottomsheetDropdown } from "../../../../../components";

// project imports
import Utils from "./utils";

// css imports
// import "../../optimization-card/family-collapse-view.css";

const SaralJeevanBima = ({ form, data }) => {

  return (
    <div className=''>
      <div className='mx-0 my-4'>
        {/* <Col xs={12} md={6}> */}
        {/* <div className='mb-2 font-size-12 font-weight-light '>{form.$("policy-term").label}</div> */}
        <BottomsheetDropdown
          dropdownStyle='font-size-lg-12 font-size-14 font-weight-light'
          menuItemFontStyle='font-size-lg-12 font-size-14 font-weight-light'
          menuItemStyle='d-flex justify-content-between align-items-center'
          selectedLabelKey='label'
          bottomsheetTitle={form.$("policy-term").label}
          menuList={form.$("policy-term").extra.options}
          value={form.$("policy-term").value}
          onSelect={form.$("policy-term").onChange}
          disabled={false}
        />
        {/* </Col> */}
      </div>
      <div className='mx-0 my-4'>
        {/* <Col xs={12} md={6} className='mt-2 product-form'> */}
        {/* <div className='mb-2 font-size-12 font-weight-light '>{form.$("premium-paying-term").label}</div> */}
        <BottomsheetDropdown
          dropdownStyle='font-size-lg-12 font-size-14 font-weight-light'
          menuItemFontStyle='font-size-lg-12 font-size-14 font-weight-light'
          menuItemStyle='d-flex justify-content-between align-items-center'
          selectedLabelKey='label'
          bottomsheetTitle={form.$("premium-paying-term").label}
          menuList={Utils.generatePPT(form.$("policy-term").value.id, form.$("payment-frequency").value.id)}
          value={form.$("premium-paying-term").value}
          onSelect={form.$("premium-paying-term").onChange}
          disabled={false}
        />
        {/* </Col> */}
      </div>
    </div >
  );
};

export default observer(SaralJeevanBima);
